import styled from 'styled-components';

import { H2, H3, P } from '../../typography';

/* ------------------------- StyledRegistrationHeadingSection -------------------------- */

export const Title = styled(H2)`
    line-height: 130%;
    padding: 0;
    text-align: center;
`;

export const Subtitle = styled(H3)`
    line-height: 130%;
    padding: 0;
    text-align: center;
`;

export const Body = styled(P)`
    padding-top: 1rem;
    padding-bottom: 0;
    text-align: center;
`;

/* ---------------------------- Main Styled Component ------------------------------- */

export const StyledRegistrationHeadingSection = styled.div(
    ({ theme }) => `
        color: ${theme.sections.page.a};
        margin: 1.5rem 0.5rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    `,
);
